/**
 * proof-carousel.js
 *
 * Activates Splide.js carousel on .k-column-layout--carousel elements.
 *
 * Visible panels by breakpoint:
 *   Desktop  ≥1024px : 3 panels visible, arrows shown
 *   Tablet   640–1023px : 2 panels visible + peek, arrows shown
 *   Mobile   <640px  : 1 panel visible + peek, swipe only (no arrows)
 *
 * Prev/next arrows hide automatically when at track boundaries.
 */

(function (Drupal) {
  'use strict';

  var SELECTOR = '.k-column-layout--carousel';
  var OBSERVED = 'k-carousel-init';

  function initCarousel(el) {
    if (el.classList.contains(OBSERVED)) { return; }
    el.classList.add(OBSERVED);

    var cols = el.querySelectorAll(':scope > .k-column-layout__col');
    if (!cols.length) { return; }

    /* Wrap existing col divs in Splide markup */
    var track = document.createElement('div');
    track.className = 'splide__track';

    var list = document.createElement('ul');
    list.className = 'splide__list';

    cols.forEach(function (col) {
      var slide = document.createElement('li');
      slide.className = 'splide__slide';
      slide.appendChild(col);
      list.appendChild(slide);
    });

    track.appendChild(list);
    el.classList.add('splide');
    el.appendChild(track);

    var splide = new Splide(el, {
      type       : 'slide',
      perPage    : 3,
      perMove    : 1,
      gap        : '1.5rem',
      arrows     : true,
      pagination : false,
      keyboard   : true,
      breakpoints: {
        1023: {
          perPage : 2,
          gap     : '1rem',
          padding : { right: '3rem' }, /* peek next card */
        },
        639: {
          perPage : 1,
          gap     : '1rem',
          padding : { right: '2rem' },
          arrows  : false,             /* swipe only on mobile */
        },
      }
    });

    splide.mount();
  }

  function init(context) {
    if (typeof Splide === 'undefined') { return; }
    var selector = SELECTOR + ':not(.' + OBSERVED + ')';
    var els = (context || document).querySelectorAll(selector);
    Array.prototype.forEach.call(els, initCarousel);
  }

  /* ── Drupal behavior ── */
  if (typeof Drupal !== 'undefined') {
    Drupal.behaviors.kProofCarousel = {
      attach: function (context) { init(context); }
    };
  } else {
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', function () { init(document); })
      : init(document);
  }

})(typeof Drupal !== 'undefined' ? Drupal : {});
